import { ITheme } from "../../utils/theme";

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}


export const successMsgStyle = {
  color: (theme: ITheme) => theme.palette.blue[600],
  minHeight: 'calc(100vh - 190px)'
}

export const placeholderStyle = {
  color: (theme: ITheme) => theme.palette.grey[400]
}